import {Carousel} from "@mantine/carousel";
import classNames from "classnames";
import {isEmpty} from "lodash";
import pluralize from "pluralize";
import React, {useState} from "react";

import classes from "./MediaCarousel.module.scss";
import type {Media} from "../../graphql/types";
import MediaImage from "../MediaImage";

export interface MediaCarouselProps {
  mediaList: Partial<Media>[];
  initialMediaIndex?: number;
  small?: boolean;
}

/**
 * Cyclable carousel of media images
 */
export default function MediaCarousel({
  mediaList,
  initialMediaIndex,
  small = false,
}: MediaCarouselProps) {
  const [slideIndex, setSlideIndex] = useState<number>(initialMediaIndex || 0);
  const filteredMediaList = mediaList.filter(
    (media: Partial<Media>) => media.url
  );

  const totalSlides = filteredMediaList.length;

  return (
    <>
      {!isEmpty(mediaList) && (
        <div className={classes.mediaCarouselWrapper}>
          <Carousel
            height={small ? 310 : 512}
            withControls={mediaList.length > 1}
            withIndicators={mediaList.length > 1}
            className={classNames(classes.mediaCarousel, {small})}
            onSlideChange={setSlideIndex}>
            {filteredMediaList.map((media: Partial<Media>) => (
              <Carousel.Slide key={media.id}>
                <div className={classes.mediaImageWrapper}>
                  <MediaImage className={classes.mediaImage} media={media} />
                </div>
              </Carousel.Slide>
            ))}
          </Carousel>
          <div className={classes.photoCount}>
            {`${(slideIndex + 1).toLocaleString()} of ${totalSlides.toLocaleString()} ${pluralize("photo", totalSlides)}`}
          </div>
        </div>
      )}
    </>
  );
}
